import { Injectable } from '../../../node_modules/@angular/core';

@Injectable()
export class CommonUtil {

public static UTCToLocalTimeStamp(value: any) {
    if (value) {
        value = value.toString() + 'Z';
        const dt = new Date(value);
        return new Date(dt);
        }
    return null;
}

public static localToUTC(value: any) {
    if (value) {
      const dt = new Date(value);
      dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
      return new Date(dt.toISOString().substring(0, 10));
    }

    return null;
  }

  public static UTCToLocal(value: any) {
    if (value) {
      return new Date(value);
    }
    return null;
  }
}
